import callApi, { CallApiResult } from 'src/api';
import CartRequestDTO from 'src/entities/cart/request/CartRequestDTO';

export const fetchExpertiseCall = (): Promise<CallApiResult> => {
    const endpoint = `/api/complaints/offers`;
    return callApi(endpoint);
};

export const fetchStartExpertise = (claimId: string): Promise<CallApiResult> => {
    const endpoint = `/api/complaints/` + claimId + `/startAnalyze`;
    return callApi(endpoint, { method: 'PUT' });
};

export const fetchStopExpertise = (claimId: string): Promise<CallApiResult> => {
    const endpoint = `/api/complaints/` + claimId + `/cancelAnalyze`;
    return callApi(endpoint, { method: 'PUT' });
};

export const sendRepairOffer = (data: CartRequestDTO): Promise<CallApiResult> => {
    const endpoint = `/ordering/serviceOffer`;
    return callApi(endpoint, { method: 'POST', data });
};
